import type { ReactNode } from 'react';
import { Button, type ButtonProperties } from 'ui';
import { useDirectMessageNode } from './hooks';

const DirectMessageButtonNode = ({
  children,
  className,
  icon,
  size = 'large',
  type,
  user,
  viewer,
}: {
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  size?: ButtonProperties['size'];
  type?: 'link-secondary' | 'primary' | 'tertiary' | 'text';
  user: { _id: string; email: string; firstName: string; lastName: string };
  viewer: { _id: string };
}) => {
  const { handleDirectMessage } = useDirectMessageNode();

  return viewer._id === user._id ? null : (
    <Button
      className={className}
      icon={icon}
      onClick={(event) => {
        event.preventDefault();
        void handleDirectMessage(user);
      }}
      size={size}
      type={type}
    >
      {children}
    </Button>
  );
};

export default DirectMessageButtonNode;
